import { DefaultResponseModel } from "@/types/http";
import http from "../utils/http-client";

export interface ManageUserModel {
  id: number;
  username: string;
  email: string;
  status:string
}

/**
 * 获取所有管理员
 */
export const getAllAdmins = () => {
  return http.get<Array<ManageUserModel>>({
    url: "/api/super/users",
  });
};

/**
 * 检测是否超级管理员
 */
export const checkIsSuperAdmin = () => {
  return http.get<Role>({
    url: "/api/super/role",
  });
};

/**
 * 注册超级用户
 */
export const registerAdmin = (
  username: string,
  password: string,
  email: string
) => {
  return http.post<DefaultResponseModel>({
    url: "/api/register",
    data: {
      username,
      password,
      email,
      is_admin: true,
    },
    unprocessed: true,
  });
};

/**
 * 删除用户
 */
export const deleteAdmin = (user_id: number) => {
  return http.delete<DefaultResponseModel>({
    url: "/api/super/delete/" + user_id,
    unprocessed: true,
  });
};



/**
 * 解锁或锁定用户
 */
export const lockOrUnlockAdmin = (user_id: number) => {
    return http.post<DefaultResponseModel>({
      url: "/api/super/lock/" + user_id,
      unprocessed: true,
    });
  };
  